import { GOAL_COLORS } from '../colors';

/**
 * Five swatches and Auto.
 *
 * Auto is first and is the default, because a palette whose entries all have to be chosen is a
 * palette nobody uses — no goal on either of the owner's real accounts had ever had a colour set
 * before Phase 40 made "auto" mean a real colour instead of grey.
 *
 * Radios rather than buttons: this is one choice from a fixed set, which is what a radio group is,
 * and it gets arrow-key navigation and a group label for free.
 */
export function ColorPicker({
  value,
  onChange,
  label,
  name,
}: {
  value: string | null;
  onChange: (next: string | null) => void;
  label: string;
  /** Radios need a group name unique to this instance, or two pickers share one selection. */
  name: string;
}) {
  return (
    <fieldset className="color-picker">
      <legend className="subtext">{label}</legend>
      <label className="swatch-option" title="Auto — inherited, or chosen by position">
        <input type="radio" name={name} checked={value === null} onChange={() => onChange(null)} />
        <span className="swatch-auto">Auto</span>
      </label>
      {GOAL_COLORS.map((color) => (
        <label key={color} className="swatch-option" title={color}>
          <input
            type="radio"
            name={name}
            checked={value === color}
            onChange={() => onChange(color)}
          />
          {/* The colour name is the accessible label; the square is decoration on top of it. */}
          <span className={`swatch goal-c-${color}`} />
          <span className="sr-only">{color}</span>
        </label>
      ))}
    </fieldset>
  );
}
